export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "Strona internetowa",
    introCreated:
      "Twoja strona internetowa jest już gotowa. Wejdź i edytuj ją, kiedy tylko chcesz.",
    introEmpty:
      "Utwórz stronę internetową swojego obiektu razem z wbudowanym kalendarzem. Edytujesz ją, przeciągając elementy, bez pisania kodu.",
    emptyTitle: "Nie masz jeszcze strony internetowej",
    emptyBody:
      "Wybierasz szablon dla swojej branży, podmieniasz zdjęcia i teksty i masz stronę gotową do publikacji. Wyszukiwarka dat pozostaje połączona z Twoim kalendarzem.",
    creating: "Tworzenie…",
    createCta: "Utwórz moją stronę",
    createAnother: "Utwórz kolejną stronę",
    collapse: "Zwiń",
    expand: "Zobacz szczegóły",
    limitReached: "Twój plan pozwala na tyle stron: {n}.",
    lockedTitle: "Strona internetowa jest częścią planu Suite",
    lockedBody:
      "Aby tworzyć stronę internetową obiektu w WACheckin i nią zarządzać, potrzebny jest aktywny plan Suite.",
    lockedCta: "Zobacz plan Suite",
    nameLabel: "Nazwa Twojej strony",
    viewWeb: "Zobacz stronę",
    opening: "Otwieranie…",
    editCta: "Edytuj moją stronę",
    noPublicAddress: "Nie ma jeszcze publicznego adresu",
    published: "Opublikowana",
    unpublished: "Nieopublikowana",
    visibleToPublic: "Widoczna publicznie",
    addressTitle: "Adres Twojej strony",
    addressSubtitle: "Wybierz, pod jakim adresem mają ją widzieć goście.",
    modeWacheckin: "Użyj adresu WACheckin",
    modeWacheckinHint: "Bezpłatny i gotowy od razu",
    modeOwn: "Użyj własnej domeny",
    modeOwnHint: "Jeśli już ją masz",
    subdomainLabel: "Słowo, które będzie z przodu",
    subdomainPlaceholder: "nazwa-mojego-obiektu",
    saving: "Zapisywanie…",
    save: "Zapisz",
    subdomainPreview: "Twoja strona będzie pod adresem",
    subdomainFree:
      "Wpisz, jak chcesz: zamienimy to na prawidłowy adres.",
    otherDomainNote:
      "Masz też podłączoną domenę {dominio}. Ten adres nadal będzie działać i prowadzić do tej samej strony.",
    noDomainYet: "Nie wiadomo jeszcze, jakiej domeny chcesz użyć",
    continueConnection: "Kontynuuj podłączanie",
    connectDomain: "Podłącz moją domenę",
    searchTitle: "Które obiekty może pokazywać wyszukiwarka",
    searchSubtitle:
      "Zaznaczone tutaj obiekty zobaczą goście przy wyszukiwaniu terminów.",
    missingPhotosLabel: "Brak zdjęć:",
    missingPhotosHelp:
      "Wgraj je w Rezerwacjach bezpośrednich → Zdjęcia, a pojawią się tutaj. Nie muszą być wystawione na sprzedaż.",
    previewError: "Nie udało się wczytać podglądu.",
    previewRetry: "Spróbuj ponownie",
    deleteExplain: "Usuwa stronę i całą jej zawartość. Tej operacji nie da się cofnąć.",
    deleteTitle: "Usunąć „{nombre}”?",
    deleteBody: "Tej operacji nie da się cofnąć. Jeśli chcesz ją tylko ukryć, wyłącz opcję „Widoczna publicznie”, a strona pozostanie zapisana.",
    deleteItemPages: "Jej podstrony w liczbie {n} wraz z tekstami i wyglądem",
    deleteItemAddress: "Adres, pod którym jest udostępniana",
    deleteItemMessages: "Wiadomości otrzymane przez jej formularze",
    deleteCancel: "Anuluj",
    deleteConfirm: "Tak, usuń",
    deleting: "Usuwanie…",
    previewTitle: "Twoja strona w tej chwili",
    previewDesktop: "Komputer",
    previewMobile: "Telefon",
    previewLoading: "Wczytywanie Twojej strony…",
    previewNote: "Tak wygląda z ostatnio zapisanymi zmianami. Goście widzą to, co zostało opublikowane ostatnim razem.",
    footerNote:
      "Na razie każde konto ma jedną stronę internetową. Napisz do nas, jeśli potrzebujesz więcej.",
    deleteWeb: "Usuń tę stronę",
    mensajes: {
      title: "Wiadomości z Twojej strony",
      subtitle: "To, co ludzie piszą w formularzach na Twojej stronie. Każda wiadomość dociera też na e-mail.",
      inbox: "Skrzynka odbiorcza",
      archived: "Zarchiwizowane",
      unread: "Nieprzeczytane: {n}",
      empty: "Nikt jeszcze nie napisał. Gdy ktoś wypełni formularz na Twojej stronie, zobaczysz to tutaj i dostaniesz wiadomość e-mail.",
      emptyArchived: "Nie masz zarchiwizowanych wiadomości.",
      loadError: "Nie udało się wczytać wiadomości.",
      retry: "Spróbuj ponownie",
      reply: "Odpowiedz e-mailem",
      whatsapp: "WhatsApp",
      call: "Zadzwoń",
      markRead: "Oznacz jako przeczytane",
      markUnread: "Oznacz jako nieprzeczytane",
      archive: "Archiwizuj",
      unarchive: "Przenieś do skrzynki odbiorczej",
      delete: "Usuń",
      confirmDelete: "Usunąć tę wiadomość? Tej operacji nie da się cofnąć.",
      confirmYes: "Tak, usuń",
      confirmNo: "Nie",
      form: "Formularz",
      from: "Od",
      more: "Wczytaj więcej",
      anonymous: "Bez nazwy",
      replySubject: "Twoja wiadomość na {sitio}",
      notSent: "Powiadomienie e-mail jeszcze nie wyszło.",
      errorAction: "Nie udało się zapisać zmiany. Spróbuj ponownie.",
    },
    loadingAccommodations: "Wczytywanie Twoich obiektów…",
    noPhotosYet:
      "Żaden z Twoich obiektów nie ma jeszcze zdjęć. Wgraj je w Rezerwacjach bezpośrednich → Zdjęcia, a będzie je można tutaj pokazać.",
    noAccommodations: "Nie masz jeszcze utworzonych obiektów.",
    loadError: "Nie udało się wczytać Twoich stron.",
    defaultSiteName: "Mój obiekt",
    createError: "Nie udało się utworzyć strony.",
    saveError: "Nie udało się zapisać.",
    subdomainTooLong: "Wyszło za długie.",
    subdomainReserved: "To słowo jest zarezerwowane. Spróbuj innego.",
    addressSaved: "Adres zapisany.",
    subdomainChecking: "Sprawdzanie, czy jest wolny…",
    subdomainAvailable: "Jest wolny. Twoja strona będzie pod adresem",
    subdomainChangeWarning: "Po zapisaniu obecny adres przestanie działać.",
    subdomainTaken: "Inna strona już używa tego adresu.",
    subdomainTryThis: "Ten jest wolny:",
    subdomainUse: "Użyj tego",
    subdomainGeneric: "Nic nie mówi o Twoim obiekcie. Proponujemy:",
    subdomainProposal: "Proponujemy adres z nazwą Twojego obiektu:",
    domainHelpEmpty:
      "Poprowadzimy Cię krok po kroku: wpisujesz domenę, kopiujesz dwie linie do panelu, w którym ją kupiłeś, a my to sprawdzamy.",
    domainHelpPending:
      "W panelu Twojej domeny brakuje wpisów albo nie rozpropagowały się jeszcze wszędzie. Wejdź, a my to sprawdzimy.",
    popupBlocked: "Zezwól na wyskakujące okna, aby otworzyć edytor.",
    editorError: "Nie udało się otworzyć edytora.",
    confirmDelete: `Usunąć "{nombre}"? Strona przestanie się wyświetlać.`,
    deleteError: "Nie udało się usunąć.",
  },

  selectOta: {
    lockBadge: "Funkcja subskrypcji",
    lockTitle: "Podłącz swoje OTA z aktywnym planem",
    lockText:
      "Aby synchronizować <b>Booking, Airbnb, Vrbo, Expedia</b> i inne kanały z WA&nbsp;Checkin, trzeba mieć wykupiony plan. Przy aktywnej subskrypcji Janet synchronizuje ceny, dostępność i rezerwacje automatycznie: bez overbookingu i bez pracy ręcznej.",
    morePreviewTitle: "i ponad 100 OTA",
    otasAvailable: "dostępnych OTA",
    lockCta: "Zobacz plany i wykup subskrypcję",
    lockFoot:
      "Automatyczna synchronizacja · Ochrona przed overbookingiem · Wsparcie przy podłączeniu w cenie",
    connectOtaTitle: "Podłącz OTA",
    googleFaltan: "Twojej ofercie brakuje 1 rzeczy do Google | Twojej ofercie brakuje {count} rzeczy do Google | Twojej ofercie brakuje {count} rzeczy do Google",
    googlePreparar: "Przygotuj ją",
    beta: "Beta",
    pctChipTitle: "Procent taryfy pochodnej dla tego OTA",
    comingSoon: "Wkrótce",
    manage: "Zarządzaj",
    connectNow: "Podłącz teraz",
    pctModalTitle: "Procent taryfy",
    pctModalHint:
      "O ile procent więcej (lub mniej) chcesz pobierać od gości, którzy rezerwują przez <b>{ota}</b>? Użyj <b>+</b>, aby pobierać więcej, albo <b>−</b>, aby pobierać mniej (np.: <b>15.5</b> lub <b>−10</b>).",
    thisOta: "to OTA",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz",
    exploreMore: "Poznaj ponad 100 dostępnych OTA",
    activeConnections: "Aktywne połączenia",
    searchPlaceholder: "Szukaj...",
    loadingConnections: "Wczytywanie połączeń...",
    thChannel: "KANAŁ",
    thConnectionId: "ID POŁĄCZENIA",
    thLastSync: "OSTATNIA SYNCHRONIZACJA",
    thActions: "AKCJE",
    copied: "Skopiowano!",
    copyId: "Kopiuj ID",
    contactTitle: "Połącz z {name}",
    contactDescription:
      "Wygodnie podłącz swoje konto {name} do naszej platformy, aby usprawnić pracę. Wykonaj poniższe kroki, aby zakończyć proces.",
    step1Title: "Utwórz konto {name}",
    step1Description:
      "Jeśli nie masz jeszcze konta {name}, najpierw trzeba je założyć.",
    createAccountLink: "Utwórz konto →",
    step1Hint: "Masz już konto? Przejdź do kroku 2.",
    step2Title: "Skontaktuj się z zespołem wsparcia",
    step2Description:
      "Gdy konto {name} będzie gotowe, nasz zespół pomoże je podłączyć.",
    contactSupportLink: "Skontaktuj się z zespołem wsparcia →",
    connectDirectNoSupport: "Podłącz bezpośrednio (bez wsparcia) →",
    step2Hint: "Zalecane tylko wtedy, gdy wiesz, co masz skonfigurować w Channex.",
    connectDirectly: "Podłącz bezpośrednio",
    iframeTitle: "Połącz z {channel}",
    iframeSubtitle: "Bezpieczne połączenie obsługiwane przez channel manager",
    close: "Zamknij",
    iframeLoading: "Otwieranie bezpiecznego połączenia…",
    actionRequired: "Wymagane działanie",
    viewPlans: "Zobacz plany",
    descBooking: "Dotrzyj do podróżnych służbowych i wypoczynkowych na całym świecie",
    descAirbnb: "Połącz swój obiekt z milionami podróżnych na Airbnb",
    descVrbo: "Specjalizuje się w wynajmie wakacyjnym dla rodzin",
    descExpedia: "Globalna sieć turystyczna z milionami aktywnych użytkowników",
    descBnb: "Włoski portal dla B&B i obiektów z charakterem",
    descGvr: "Pojawiaj się bezpłatnie w wynikach i mapach Google",
    descAgoda: "Dotrzyj do podróżnych z Azji i reszty świata",
    descHotelbeds: "Noclegi dla biur podróży i touroperatorów na całym świecie",
    savePercentError: "Nie udało się zapisać procentu. Spróbuj ponownie.",
    channelGeneric: "Kanał",
    statusInactive: "Nieaktywny",
    statusConnected: "Połączony",
    statusSyncing: "Synchronizacja",
    webReservationsName: "Rezerwacje bezpośrednie przez stronę",
  },

  connectionChannel: {
    errorTitle: "Błąd",
    successTitle: "Gotowe",
    connectionDisabled: "Połączenie jest wyłączone",
    syncError: "Błąd podczas synchronizacji",
    loadPropertiesError: "Błąd przy wczytywaniu obiektów",
    connectionUpdated: "Połączenie zaktualizowane {channelName}",
    updateConnError: "Błąd przy aktualizacji połączenia: {detail}",
    unknownError: "Nieznany błąd",
    connectionWith: "Połączenie z {channelName} {status}",
    stateUpdatedTitle: "Status zaktualizowany",
    confirmDeleteMessage:
      "Czy na pewno usunąć to połączenie? Usunięte zostaną także powiązane obiekty i rezerwacje.",
    confirmDeleteHeader: "Potwierdź usunięcie",
    deleteConnection: "Usuń połączenie",
    no: "Nie",
    connectionDeleted: "Połączenie zostało usunięte",
    deleteConnError: "Błąd przy usuwaniu połączenia: {detail}",
    webhookCopied: "Webhook skopiowany do schowka",
    webhookCopyError: "Błąd przy kopiowaniu webhooka",
    title: "Kanał połączenia (PMS)",
    description:
      "W tej sekcji można połączyć się z systemami zarządzania obiektami (PMS), aby sprawnie i bezbłędnie sprawdzać dane, zarządzać nimi i je aktualizować.",
    connectedAccount: "Połączone konto",
    switchTooltip:
      "Zatrzymaj lub uruchom usługę, która automatycznie pobiera rezerwacje do systemu.",
    syncing: "Synchronizacja...",
    sync: "Synchronizuj",
    deleting: "Usuwanie...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "Dodaj ten Webhook do swojego konta Smoobu, aby automatycznie pobierać rezerwacje utworzone w Twoim PMS",
    copyToClipboard: "Kopiuj do schowka",
    syncedProperties: "Zsynchronizowane obiekty",
    noAddress: "Brak adresu",
    noSyncedProperties: "Nie ma zsynchronizowanych obiektów",
  },

  wabaIntegration: {
    activationInProgress: "Aktywacja w toku",
    pendingBody:
      "Trwa aktywacja WhatsApp dla Pana/Pani firmy. Zanim Meta zatwierdzi szablony (zwykle trwa to do 24&nbsp;h) i zweryfikuje numer, wiadomości są wysyłane z <strong>WhatsAppa WACheckin</strong>, aby komunikacja z gośćmi nie została przerwana. Przełączenie na własny numer nastąpi <strong>automatycznie</strong>, gdy tylko będzie gotowy; nie trzeba nic robić.",
    phoneStatusHeading: "Status numeru WhatsApp",
    numberLabel: "Numer:",
    virtualNumberNote:
      "To jest <strong>numer wirtualny udostępniony przez Meta</strong>. Nie odbiera zwykłych połączeń ani SMS, tylko wiadomości WhatsApp przez API.",
    statusLabel: "Status:",
    templatesStatusHeading: "Status szablonów",
    canSend:
      "Numer jest <strong>połączony i zweryfikowany</strong>, a co najmniej jeden szablon został zatwierdzony. Można już wysyłać wiadomości.",
    cannotSendYet:
      "<strong>Nie można jeszcze wysyłać wiadomości</strong>. Poczekaj, aż Meta zatwierdzi numer telefonu i szablony.",
    virtualPendingNote:
      "Uwaga: jeśli firma nie jest zweryfikowana w Meta, numery wirtualne mogą pozostawać w statusie <strong>oczekujący</strong> i nie pozwalać na wysyłkę.",
    statusConnectedVerified: "Połączony i zweryfikowany",
    statusConnectedPending: "Połączony, oczekuje na weryfikację",
    statusPendingApproval: "Oczekuje na zatwierdzenie",
    statusDisconnected: "Rozłączony",
    statusUnknown: "Nieznany",
  },
};
